"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const SVG_1 = __importDefault(require("./SVG"));
const Icon = (0, styled_components_1.default)(SVG_1.default) `
    polygon,
    rect {
        ${({ disabled, theme }) => {
    if (disabled) {
        return (0, styled_components_1.css) `
                    fill: ${theme.colorControlIconDisabled};
                `;
    }
    return (0, styled_components_1.css) `
                fill: ${theme.colorControlElement};
            `;
}}
    }
`;
const Checkbox = ({ disabled, mode }) => (react_1.default.createElement(Icon, { disabled: disabled, viewBox: "0 0 20 20", width: "20px", height: "20px" },
    mode === 'selected' && (react_1.default.createElement("polygon", { "data-selector-id": "grid-checkbox-selected-polygon", points: "8 15.5 17 6.5 15 4.5 8 11.5 5 8.5 3 10.5 8 15.5" })),
    react_1.default.createElement("path", { "data-selector-id": "grid-checkbox-path", d: "M0,0V20H20V0ZM19,19H1V1H19Z" }),
    mode === 'indeterminate' && (react_1.default.createElement("rect", { "data-selector-id": "grid-checkbox-selected-rect", x: "5", y: "5", width: "10", height: "10" }))));
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map